export default __webpack_public_path__ + "static/media/not_actice_order_report.6ba1f501.svg";